export enum ReportType {
  BUSINESS_PROFILE = 'BUSINESS_PROFILE',
  REPRESENTATIVE_PROFILE = 'REPRESENTATIVE_PROFILE',
  CENSUS = 'CENSUS',
  TRANSACTIONS = 'TRANSACTIONS',
  COUPONS = 'COUPONS',
  VIP_COUPONS = 'VIP_COUPONS',
  POINT_TRANSACTIONS = 'POINT_TRANSACTIONS',
  EXPIRING_POINTS = 'EXPIRING_POINTS',
}

export enum DateFilterStrategy {
  SIX_MONTHS = 'SIX_MONTHS',
  TWELVE_MONTHS = 'TWELVE_MONTHS',
  TWENTY_FOUR_MONTHS = 'TWENTY_FOUR_MONTHS',
  DATE_RANGE = 'DATE_RANGE',
  ALL_TIME = 'ALL_TIME',
}

export enum DateFilterStrategyLabel {
  SIX_MONTHS = 'Last 6 months',
  TWELVE_MONTHS = 'Last 12 months',
  TWENTY_FOUR_MONTHS = 'Last 24 months',
  DATE_RANGE = 'Specific date',
  ALL_TIME = 'All time',
}
